/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import { SiteAttachmentService } from './SiteAttachmentService';

class SiteAttachmentServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new SiteAttachmentService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { SiteAttachmentServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/SiteAttachmentServiceProvider.js